import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const TimeCoinsIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';

    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path
                d="M19.7726 9.00081C18.7242 4.4084 14.3124 1.40099 9.65452 2.10364C4.99665 2.80629 1.66829 6.98131 2.02125 11.6786C2.37422 16.376 6.28913 20.0067 10.9997 20.0054"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.87158 14.0017L14.0002 7.87305"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1359 13.0359C13.1611 13.063 13.1611 13.1048 13.1359 13.1319C13.1232 13.1447 13.1059 13.1519 13.0879 13.1519C13.0699 13.1519 13.0526 13.1447 13.0399 13.1319C13.0134 13.1054 13.0134 13.0624 13.0399 13.0359C13.0664 13.0094 13.1094 13.0094 13.1359 13.0359"
                stroke="currentColor"
                strokeWidth="2.24906"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.74006 8.8387C8.7149 8.81164 8.7149 8.76976 8.74006 8.7427C8.75274 8.72987 8.77002 8.72266 8.78806 8.72266C8.80609 8.72266 8.82338 8.72987 8.83606 8.7427C8.86257 8.76921 8.86257 8.81219 8.83606 8.8387C8.80955 8.86521 8.76657 8.86521 8.74006 8.8387"
                stroke="currentColor"
                strokeWidth="2.24906"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.2531 17.2519V14.2506C23.2531 13.421 21.5724 12.75 19.5016 12.75C17.4307 12.75 15.7511 13.4221 15.75 14.2506V20.2531C15.7511 21.0817 17.4296 21.7537 19.5016 21.7537C21.5735 21.7537 23.2521 21.0817 23.2531 20.2531V14.2506"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.751 14.25C15.751 15.0786 17.4306 15.7506 19.5025 15.7506C21.5745 15.7506 23.253 15.0786 23.253 14.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.751 17.252C15.751 18.0805 17.4306 18.7526 19.5025 18.7526C21.5745 18.7526 23.2541 18.0805 23.2541 17.252"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default TimeCoinsIcon;
